import { useTask } from "../../../../hooks";
import Button from "../../../UI/Button";
import Preloader from "../../../UI/Preloader";
import { TypeTask } from "./components/TypeTask";
import s from "./index.module.css";
import { listOptions } from "./listOptions";
import { directionAPI } from "../../../../api";
import { useEffect, useState } from "react";
import setSettingsFromServer from "@/helpers/setSettingsFromServer"

export const EditMode = ({
  data,
  save,
  saveLS,
  cancelLS,
  removeLS,
  direction,
}) => {

  const [settings, setSettings] = useState(null);
	useEffect(() => {
		setSettingsFromServer(setSettings)
	}, []);

	const isAbilityToMarkAllAssignmentsByTopic = settings?.isAbilityToMarkAllAssignmentsByTopic == '1';
  //подтему отображаем, если разрешено в настройках платформы и в настройках платформы также разрешено отображать тему(подтема не может быть без темы)
	const isAbilityToMarkAllAssignmentsBySubTopic = (settings?.isAbilityToMarkAllAssignmentsBySubTopic == '1') && isAbilityToMarkAllAssignmentsByTopic;
	const isAbilityToMeasureEachTaskByPoints = settings?.isAbilityToMeasureEachTaskByPoints == '1';
  

  
  const [directionInfo, setDirectionInfo] = useState(null);
  const [
    state,
    setState,
    onSave,
    onCancel,
    del,
    setErrorsList,
    showErrors,
    loading,
  ] = useTask(data, save, saveLS, cancelLS, removeLS);

  useEffect(() => {
    directionAPI.get({ id: data.direction_id }).then((res) => {
      setDirectionInfo(res.data);
    });
  }, []);
  const forProbe = window.location.href.includes('/direction-editor/probe-') || state?.is_probe == '1';
  const params = {
    themeVisible: !!isAbilityToMarkAllAssignmentsByTopic,
    subThemeVisible: !!isAbilityToMarkAllAssignmentsBySubTopic,
    forProbe,
    weightVisible: !!isAbilityToMeasureEachTaskByPoints
  }

  return (
    <>
      <TypeTask type={data.type} />
      <h3 className={s.title}>{data.title}</h3>
      <div className={s.list}>
        {state &&
          listOptions(state.type, directionInfo?.flag_easily_creating, params).map(
            (El, index) => {
              return (
                <El
                  key={index}
                  data={state}
                  edit={setState}
                  direction={direction}
                  setErrorsList={setErrorsList}
                  showErrors={showErrors}
                  flagEasily={directionInfo?.flag_easily_creating}
                  forProbe={forProbe}
                />
              );
            }
          )}
      </div>

      <div className={s.buttonsWrap}>
        {loading ? (
          <Preloader />
        ) : (
          <Button newDesign newDesignYellow action={onSave}>
            {data.id ? "Сохранить" : "Добавить"}
          </Button>
        )}
        <Button newDesign action={onCancel}>{data.id ? "Отменить" : "Удалить"}</Button>
        {data.id && (
          <Button newDesign styles="red" action={del}>
            {removeLS ? "Удалить из списка" : "Удалить из дз"}
          </Button>
        )}
        {/* <Button styles='gray'>Архивировать</Button> */}
      </div>
    </>
  );
};
